import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';
import { getGameImages } from '../../../core/helpers/getGameImages';
import { isMobile } from '../../../core/helpers/isMobile';
import { bettingPartStore } from '../../../store/bettingPartStore';
import { applicationStore } from '../../../store/applicationStore';
import { gameStore } from '../../../store/gameStore';
import { boostedJackpotStore } from '../../../store/boostedJackpotStore';
import BoostedJackpotIconView from './boostedJackpotIconView';
import BoostedJackpotIconSliderBoardWrapper from './boostedJackpotIconSliderBoardWrapper';
import { userInfoStore } from '../../../store/userInfoStore';

const BoostedJackpotIcon = observer(() => {
  const { boostedJackpotIconInfoBoard, boostedJackpotIconInfoBoardRectangle } = getGameImages();
  const { isReplay } = userInfoStore;
  const { setIsShowBlackLayer } = applicationStore;
  const { selectedQuickBet } = bettingPartStore;
  const { setIsSpinStart, isSpinStart } = gameStore;
  const { boostedBetAmount, isBoostedJackpot, setIsBoostedJackpotInfoPopup } = boostedJackpotStore;

  const { containerConfigBoostedJackpotIcon, containerConfigBoostedJackpotIconSliderBoard } =
    useMemo(() => {
      return {
        containerConfigBoostedJackpotIcon: {
          x: isMobile() ? 480 : 1354,
          y: isMobile() ? 95 : 113,
        },
        containerConfigBoostedJackpotIconSliderBoard: {
          x: isMobile() ? 580 : 1450,
          y: isMobile() ? 90 : 113,
        },
      };
    }, []);

  const animationName = useMemo(() => {
    if (boostedBetAmount && boostedBetAmount <= selectedQuickBet) return 'active';
    return 'idle';
  }, [boostedBetAmount, selectedQuickBet]);

  const handlePointerUp = useCallback(() => {
    setIsSpinStart(true);
    setIsBoostedJackpotInfoPopup(true);
    setIsShowBlackLayer(true);
  }, [setIsBoostedJackpotInfoPopup, setIsSpinStart, setIsShowBlackLayer]);

  if (!isBoostedJackpot) {
    return;
  }

  // eslint-disable-next-line consistent-return
  return (
    <>
      <BoostedJackpotIconSliderBoardWrapper
        boostedJackpotIconInfoBoardRectangle={boostedJackpotIconInfoBoardRectangle}
        containerConfigBoostedJackpotIconSliderBoard={containerConfigBoostedJackpotIconSliderBoard}
      />
      <Container {...containerConfigBoostedJackpotIcon}>
        <BoostedJackpotIconView
          isDisabled={!isSpinStart && !isReplay}
          animationName={animationName}
          handlePointerUp={handlePointerUp}
          boostedJackpotIconInfoBoard={boostedJackpotIconInfoBoard}
        />
      </Container>
    </>
  );
});

export default BoostedJackpotIcon;
